const PROFILE_CACHE_PREFIX = "sig_profile_cache_v1_";
const PROFILE_CACHE_TTL_MS = 12 * 60 * 60 * 1000;
export function readCachedProfile(mailboxKey = getMailboxCacheKey()) {
    if (!mailboxKey) {
        return null;
    }
    try {
        const raw = localStorage.getItem(storageKey(mailboxKey));
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (!parsed ||
            typeof parsed.fetchedAt !== "number" ||
            !parsed.graphUser ||
            typeof parsed.photoDataUri !== "string") {
            localStorage.removeItem(storageKey(mailboxKey));
            return null;
        }
        if (Date.now() - parsed.fetchedAt > PROFILE_CACHE_TTL_MS) {
            localStorage.removeItem(storageKey(mailboxKey));
            return null;
        }
        return {
            graphUser: parsed.graphUser,
            photoDataUri: parsed.photoDataUri,
        };
    }
    catch (_a) {
        return null;
    }
}
export function writeCachedProfile(graphUser, photoDataUri, mailboxKey = getMailboxCacheKey(graphUser.userPrincipalName || graphUser.mail || undefined)) {
    if (!mailboxKey) {
        return;
    }
    try {
        const payload = {
            graphUser,
            photoDataUri,
            fetchedAt: Date.now(),
        };
        localStorage.setItem(storageKey(mailboxKey), JSON.stringify(payload));
    }
    catch (_a) {
        // localStorage may be unavailable in some runtimes
    }
}
export function getMailboxCacheKey(fallback) {
    var _a, _b, _c, _d;
    const mailboxEmail = (_c = (_b = (_a = Office.context) === null || _a === void 0 ? void 0 : _a.mailbox) === null || _b === void 0 ? void 0 : _b.userProfile) === null || _c === void 0 ? void 0 : _c.emailAddress;
    const rawKey = (_d = (typeof mailboxEmail === "string" && mailboxEmail.trim() ? mailboxEmail : undefined)) !== null && _d !== void 0 ? _d : fallback;
    if (!rawKey) {
        return null;
    }
    return rawKey.trim().toLowerCase();
}
function storageKey(mailboxKey) {
    return `${PROFILE_CACHE_PREFIX}${mailboxKey}`;
}
